import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  setItemWithExpiracy(key: string, value: any, expiry: number): void {
    const item = {
      value : value,
      expiry: new Date().getTime() + expiry
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getItemWithExpiracy(key: string): any {
    const localStorageData = localStorage.getItem(key);
    const item = JSON.parse(localStorageData);
    if(Date.now() > item?.expiry){
      localStorage.removeItem(key);
      return null;
    }
    else{
      return item?.value;
    }
  }
}
